import { DateTime } from "luxon"

//Helpers
import { displayLocalDateTimeFromIso } from "../../../helpers/displayDates"

//PrimeReact
import { Accordion, AccordionTab } from "primereact/accordion"
import { Tooltip } from "primereact/tooltip"
import { Editor } from 'primereact/editor';

//style
import taskStyle from "../../../styles/tasks/TasksForm.module.css"

export default function TaskDisplayPanelCreated({task, getUser, getActionButton, onEditTask}){

    const baseClassName =
      task?.completedOn === null
        ? taskStyle.taskGridContainer
        : taskStyle.taskGridContainerCompleted
    const overdue =
      DateTime.fromISO(task?.dueOn, {
        zone: "utc",
      }).toLocal() < DateTime.local() && !task?.completedOn
        ? taskStyle.taskGridOverDue
        : ""

  //Convert to SOAR context
  function GetUserById(id) {
    const usr = getUser(id)
    return <>{usr ? usr.name2 : id}</>
  }

    return (
      <div className={`${baseClassName} ${overdue}`} id={task.id}>
        <Tooltip target=".tt-tooltip" />
      <div className={taskStyle.taskGridItemTitle}>
             <span className={taskStyle.taskGridDescription}>Title: </span>{" "}
          {task.title}
        </div>
        <div className={taskStyle.taskGridItemCreated}>
          <span className={taskStyle.taskGridDescription}>Created: </span>{" "}
          {displayLocalDateTimeFromIso(task.createdAt)}
        </div>
       <div className={taskStyle.taskGridItemAssignedBy}>
          <span className={taskStyle.taskGridDescription}>Assigned To: </span>{" "}
          {GetUserById(task.assignedToUserId)}
        </div>
        <div className={taskStyle.taskGridItemDue}>
          <span className={taskStyle.taskGridDescription}>Item due: </span>{" "}
          {displayLocalDateTimeFromIso(task.dueOn)}
        </div>
        {task.completedOn !== null ? (
          <div className={taskStyle.taskGridItemDone}>
            <span className={taskStyle.taskGridDescription}>Completed: </span>{" "}
            {displayLocalDateTimeFromIso(task.completedOn)}
          </div>
        ) : null}
        {getActionButton(
          task.primaryActionLabel,
          task.primaryActionUrl,
          task.primaryActionPayload,
          taskStyle.taskGridItemAction1,
          task
        )}
        {getActionButton(
          task.secondaryActionLabel,
          task.secondaryActionUrl,
          task.secondaryActionPayload,
          taskStyle.taskGridItemAction2,
          task
        )}
        <div className={taskStyle.taskGridItemNotes}>
          <Accordion>
            <AccordionTab header="Notes" headerStyle={{ padding: 0 }}>
              <Editor 
              value={task.description}
              readOnly={true}
              showHeader={false}
              style={{ wordBreak: "break-all", border: "none" }}
              />
            </AccordionTab>
          </Accordion>
        </div>
        {task?.completedOn === null && !task?.systemManaged ? (
          <div className={taskStyle.taskGridItemFunction}>
            <button
              type="button"
              className="btn"
              style={{
                float: "right",
                marginRight: 3,
                width: 40,
                height: 33,
                padding: "4px 9px",
              }}
              onClick={(e) => {
                onEditTask()
              }}
            >
              <span className={`material-icons`}> {"edit"} </span>
            </button>
          </div>
        ) : null} 
        {task?.systemManaged ? (
          <div
            className={`${taskStyle.taskGridItemFunction} tt-tooltip`}
            data-pr-tooltip="System managed task"
          >
            <span className={`material-icons`}>vpn_lock</span>
          </div>
        ) : null}
      </div>
    )
}